import type { CompleteSuccessStory } from '../../types';
import { Quote } from 'lucide-react';

interface ProblemSectionProps {
  story: CompleteSuccessStory;
}

export function ProblemSection({ story }: ProblemSectionProps) {
  const problemQuotes = story.customerQuotes.filter((q) => q.section === 'problem');

  return (
    <section className="py-20 lg:py-32">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-32">
            <span className="text-accent font-mono text-sm uppercase tracking-wider font-semibold">
              The Challenge
            </span>
            <h2 className="font-bold text-4xl lg:text-5xl mt-4 mb-6 text-primary">
              Fragmented Systems Creating Portfolio Chaos
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">{story.situationText}</p>
          </div>

          <div className="space-y-8">
            {story.problemStatements.map((problem) => (
              <div
                key={problem.id}
                className="bg-card border-l-4 border-destructive p-8 rounded-r-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <h3 className="font-bold text-xl mb-3 text-foreground">{problem.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{problem.description}</p>
              </div>
            ))}

            {problemQuotes.length > 0 && (
              <div className="bg-card rounded-2xl p-8 shadow-lg border border-border">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-gradient-to-br from-accent to-accent/80 rounded-full flex items-center justify-center">
                      <Quote className="w-7 h-7 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-xl text-foreground leading-relaxed italic mb-4">
                      {problemQuotes[0].quoteText}
                    </p>
                    <div>
                      <p className="font-bold text-lg">{problemQuotes[0].authorName}</p>
                      <p className="text-muted-foreground text-sm">{problemQuotes[0].authorTitle}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
